import React, { Component } from 'react';
import type { Store } from 'redux';
import noop from 'lodash/noop';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import type { Board } from '@atlassian/jira-navigation-types/src/types.tsx';
import type { OnBoardClick, OnNavigateUrl } from './model/index.tsx';
import rootEpic from './ops/index.tsx';
import { setUpContext } from './state/actions.tsx';
import createStore from './state/index.tsx';
import type { State } from './state/types.tsx';
import ScopeSwitcher from './view/index.tsx';

type Props = {
	isCreateBoardEnabled: boolean;
	isLocationUser: boolean;
	defaultOpen: boolean;
	locationName: string;
	currentProjectKey: string | undefined;
	currentBoard: Board | undefined;
	onBoardClick: OnBoardClick;
	onNavigateUrl: OnNavigateUrl;
	onCreateBoard: () => void;
};

// @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type.
const mapBoard = ({ id, ...rest }) => ({ id: String(id), ...rest });

// eslint-disable-next-line jira/react/no-class-components
export default class ScopeSwitcherApp extends Component<Props> {
	static defaultProps = {
		isCreateBoardEnabled: false,
		isLocationUser: false,
		defaultOpen: false,
		projectName: '',
		onCreateBoard: noop,
		onNavigateUrl: noop,
	};

	constructor(props: Props) {
		super(props);

		this.store = createStore(rootEpic);
		this.setUpContext(props);
	}

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		this.setUpContext(nextProps);
	}

	setUpContext(props: Props) {
		const { currentBoard, onBoardClick, onNavigateUrl, currentProjectKey } = props;

		this.store.dispatch(
			setUpContext({
				// @ts-expect-error - TS2322 - Type '{ id: string; } | undefined' is not assignable to type 'Board | undefined'.
				currentBoard: currentBoard ? mapBoard(currentBoard) : currentBoard,
				onBoardClick,
				onNavigateUrl,
				currentProjectKey,
			}),
		);
	}

	store: Store<State>;

	render() {
		const { defaultOpen, isCreateBoardEnabled, isLocationUser, onCreateBoard, locationName } =
			this.props;

		return (
			<AppBase store={this.store}>
				<ScopeSwitcher
					// @ts-expect-error - Property 'defaultOpen' does not exist on props
					defaultOpen={defaultOpen}
					isLocationUser={isLocationUser}
					locationName={locationName}
					hasCreateBoardButton={isCreateBoardEnabled}
					onCreateBoard={onCreateBoard}
				/>
			</AppBase>
		);
	}
}
